import { combineReducers } from 'redux'

import httpReducer from './http/httpSlice'

const rootReducer = combineReducers({
  http: httpReducer,
})

export default rootReducer
